<template>
  <div id="app">
      <router-view></router-view>   
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="less">
  @import './less/common.less';
</style>



// WEBPACK FOOTER //
// App.vue?2afd77fa